import type { AppDefinition } from '@/types/app';
import { cloneDefinitionWithIds } from '@/guidance/templates/cloneDefinition';

export interface RemixSource {
  appId: string;
  name: string;
  description?: string;
}

export interface RemixResult {
  name: string;
  description: string;
  definition: AppDefinition;
}

/**
 * Build the inputs for `createFromDefinition` when remixing a published app:
 * fresh component/screen ids (so the copy is independent), an attribution chain
 * (`remixedFrom`), and a "(Remix)" name. Pure — the screen does the create+navigate.
 */
export function buildRemix(def: AppDefinition, source: RemixSource): RemixResult {
  const definition = cloneDefinitionWithIds(def);
  definition.remixedFrom = { appId: source.appId, name: source.name };
  definition.remixable = true; // a remix is itself remixable by default
  const name = `${source.name} (Remix)`;
  definition.name = name;
  return { name, description: source.description ?? def.description ?? '', definition };
}

/** Apps are remixable by default; the creator can opt out (remixable === false). */
export function canRemix(def?: { remixable?: boolean } | null): boolean {
  return !!def && def.remixable !== false;
}
